import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { KeyboardAwareScrollView } from '@/components/with-keyboard-aware';
import {
  PadBusinessType,
  PadFormState,
  PadPaymentFormAction,
  PadPaymentFormActions,
} from '@/hooks/payments/use-pad-payment-form-reducer';
import { PadBusinessTypeSelector } from './pad-business-type-selector';
import { TextInput } from '@/components/text-input';
import { TextStyle, View } from 'react-native';

interface Props {
  dispatch: React.Dispatch<PadPaymentFormAction>;
  formState: PadFormState;
}

export const PadPaymentInfoInputs: React.FC<Props> = ({
  dispatch,
  formState,
}) => {
  const [styles, theme] = useStyles();
  const { paymentMethod, padBusinessType } = formState;

  const updatePaymentMethodField = (
    field: keyof PadFormState['paymentMethod'],
    value: string,
  ) => {
    dispatch({
      payload: { field, value },
      type: PadPaymentFormActions.SET_PAYMENT_METHOD_FIELD,
    });
  };

  const setPadBusinessType = (type: PadBusinessType) => {
    dispatch({
      payload: { padBusinessType: type },
      type: PadPaymentFormActions.SET_BUSINESS_TYPE,
    });
  };

  return (
    <>
      <KeyboardAwareScrollView
        keyboardDismissMode="on-drag"
        style={styles.contentContainer}
      >
        <View style={styles.inputFieldsContainer}>
          <View style={styles.fieldContainer}>
            <TextInput
              containerStyle={styles.inputFieldContainer}
              focusedBorderColor={theme.sk.color.border.input.active}
              label={i18n.t('pad.account_name')}
              labelStyle={theme.sk.typography.label.md as TextStyle}
              onChangeText={(value) =>
                updatePaymentMethodField('ownerName', value)
              }
              selectionColor={theme.sk.color.border.input.active}
              useOuterLabel
              value={paymentMethod.ownerName}
            />
          </View>
          <View style={styles.fieldContainer}>
            <TextInput
              containerStyle={styles.inputFieldContainer}
              focusedBorderColor={theme.sk.color.border.input.active}
              keyboardType="number-pad"
              label={i18n.t('pad.transit_number')}
              labelStyle={theme.sk.typography.label.md as TextStyle}
              onChangeText={(value) =>
                updatePaymentMethodField('bankLocationId', value)
              }
              selectionColor={theme.sk.color.border.input.active}
              useOuterLabel
              value={paymentMethod.bankLocationId}
            />
          </View>
          <View style={styles.fieldContainer}>
            <TextInput
              containerStyle={styles.inputFieldContainer}
              focusedBorderColor={theme.sk.color.border.input.active}
              keyboardType="number-pad"
              label={i18n.t('pad.institution_number')}
              labelStyle={theme.sk.typography.label.md as TextStyle}
              onChangeText={(value) =>
                updatePaymentMethodField('bankCode', value)
              }
              selectionColor={theme.sk.color.border.input.active}
              useOuterLabel
              value={paymentMethod.bankCode}
            />
          </View>
          <View style={styles.fieldContainer}>
            <TextInput
              containerStyle={styles.inputFieldContainer}
              focusedBorderColor={theme.sk.color.border.input.active}
              keyboardType="number-pad"
              label={i18n.t('pad.account_number')}
              labelStyle={theme.sk.typography.label.md as TextStyle}
              onChangeText={(value) =>
                updatePaymentMethodField('bankAccountNumber', value)
              }
              selectionColor={theme.sk.color.border.input.active}
              useOuterLabel
              value={paymentMethod.bankAccountNumber}
            />
          </View>
          <PadBusinessTypeSelector
            onChange={setPadBusinessType}
            padBusinessType={padBusinessType}
          />
        </View>
      </KeyboardAwareScrollView>
    </>
  );
};

const useStyles = createStyles((theme) => ({
  contentContainer: {
    paddingHorizontal: 16,
  },
  fieldContainer: {
    marginBottom: 16,
  },
  inputFieldContainer: {
    borderColor: theme.sk.color.border.input.default,
    borderRadius: 8,
    borderWidth: 1,
  },
  inputFieldsContainer: {
    flex: 1,
  },
}));
